import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/login/Login.vue'
import Dashboard from '../views/dashboard/DashboardHome'

Vue.use(VueRouter);

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },

    {
    path: '/dashboard',
    name: 'Dashboard',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: Dashboard
  }
];

const router = new VueRouter({
  routes
})

export default router
